import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { getSSRRenderInputs } from '@confluence/ssr-utilities/entry-points/ssrRenderInputs.ts';

import type { TapTraitAttribute } from './formatTapTraits.ts';
import { formatTapTraits } from './formatTapTraits.ts';

export type SiteUserTraits = {
	attributes: TapTraitAttribute[] | null;
};

export const preloadSiteUserTraits = async (): Promise<void> => {
	// Check if __SSR_TAP_CONTEXT__ already has siteUser traits
	if (window.__SSR_TAP_CONTEXT__?.siteUser) {
		return;
	}

	const { accessStatus, cloudId, userId } = getPreloaderFnContext();

	if (accessStatus !== 'LICENSED_USE_ACCESS' && accessStatus !== 'LICENSED_ADMIN_ACCESS') {
		return;
	}

	if (!cloudId || !userId) {
		return;
	}

	// Fallback to getSSRRenderInputs() since window.__SSR_TAP_CONTEXT__ doesn't have siteUser
	const { tapContext } = getSSRRenderInputs();
	const attributes = formatTapTraits(tapContext?.siteUser);

	if (!attributes) {
		return;
	}

	if (tapContext) {
		window.__SSR_TAP_CONTEXT__ = { ...tapContext };
	}
};
